module.exports = __webpack_public_path__ + "img/peoplepower.37114fa9.png";